module.exports = __webpack_public_path__ + "img/docker.2e0fcd7b.svg";